module.exports = __webpack_public_path__ + "static/largeog-a4324e149cae5ba51ade135ef14ecfaa.png";